import { useContext, useEffect, useState } from "react"
import { GroupContext } from "../contexts/group"
import { getReportInfoTIM } from "../axios/axiosFunctions";
import { Box, Grid, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";
import CommentIcon from '@mui/icons-material/Comment';
import { ExportTIMChartV } from "./ExportTIMChartV.jsx";

const BlockReportTIM = ({slug,blockId,color,info, onQuestionsDataReady,onFeedbackReady, groupId}) => {

    const [currentBlockText, setCurrentBlockText] = useState("");
    const {currentGroup} = useContext(GroupContext);
    const effectiveGroupId = groupId || currentGroup?._id;
    const [questions, setQuestions] = useState([]);
    const [blockTotal, setBlockTotal] = useState([]);
    const [feedbackAnsw, setFeedbackAnsw] = useState([]);

    useEffect(() => {
        const callInfo = async()=>{
            const res = await getReportInfoTIM(effectiveGroupId,blockId);
            if(res){
                const blockInfo = [res.data.pop()];
                const data = res.data.map((question)=>({
                    positive: Number(question.positivePercentage),
                    negative: Number(question.negativePercentage),
                    question: question.text
                }));
                setQuestions(data);
                if(onQuestionsDataReady) {
                    onQuestionsDataReady(data);
                }
                if(blockInfo[0].opAnswers){
                    setFeedbackAnsw(blockInfo[0].opAnswers);
                    if(onFeedbackReady) {
                        onFeedbackReady(blockInfo[0].opAnswers);
                    }
                }
                const data2 = blockInfo.map(info=>({
                    positive: Number(info.positivePercentage),
                    negative: Number(info.negativePercentage),
                    name:info.name
                }))
                setBlockTotal(data2);
            }
        }
        callInfo();
    }, [blockId, effectiveGroupId]);

    useEffect(() => {
        const infoBlock = info.find((b)=>b.block === blockId);
        setCurrentBlockText(infoBlock?.text || "");
    }, [blockId,info]);

    const wrapLabel = (s, max = 28) => {
        return s
        .split(' ')
        .reduce((lines, w) => {
            const last = lines[lines.length - 1];
            if (!last || (last + ' ' + w).length > max) lines.push(w);
            else lines[lines.length - 1] = last + ' ' + w;
            return lines;
        }, [])
        .join('\n'); // <- clave: inyecta \n
    };

    return (
    <Box display="flex" flexDirection="column" sx={{padding:"0px 48px"}}>
        <Grid container spacing={2} sx={{margin:"32px 0px 40px 0px"}}>
            <Grid size={12}>
                <Typography variant="body1" color="secondary" fontWeight={400} sx={{marginTop:"4px",lineHeight:"1.7",fontSize:"1.05rem",whiteSpace:"pre-wrap"}}>{currentBlockText}</Typography>
            </Grid>
            <Grid size={12}>
            {
                slug === "senior_leader_survey_questions" &&
                <>
                    <Typography variant="h6" color="secondary" fontWeight={600} sx={{marginBottom:"12px"}}>Senior Leader Perspective</Typography>
                    <Typography variant="body1" color="secondary" fontWeight={400} sx={{lineHeight:"1.7",fontSize:"1.05rem"}}>This section provides a complementary view of team effectiveness through the eyes of senior leaders. It reflects their assessment of the team's quality, efficiency, innovation, decision escalation, and overall alignment with organizational expectations. This perspective adds a critical external lens, ensuring the team understands how its performance is perceived by those who rely on its results and leadership impact. </Typography>
                </>
            }
            </Grid>
            <Grid size={12}>
                <Box display="flex" alignItems="center" flexDirection="column" mb={4}>
                    {questions && questions.length > 0 && (
                        <ExportTIMChartV
                        questions={questions}
                        positiveColor="#69AF45"
                        negativeColor="#2B8DCC"
                        graphHeight={400}
                        graphWidth={1200}
                        />
                    )}
                    <Box sx={{marginTop:"24px"}}>
                    {
                        questions.map((q,i)=>(
                            <Typography key={i} variant="body1" color="secondary" fontWeight={400} sx={{fontSize:"1.05rem",lineHeight:"1.7"}}>Q{i+1}. {q.question}</Typography>
                        ))
                    }
                    </Box>
                </Box>
                <Typography variant="body1" color="secondary" fontWeight={600} sx={{marginTop:"24px", marginBottom:"32px",fontSize:"1.05rem"}}>Reflection: Which of the items in this dimension resonate most as a high-priority focus area?</Typography>
                {/* {questions && questions.length !== 0 && questions.map((q, i) => (
                    <ChartTIMQuestion
                        key={i}
                        index={i}
                        question={q.question}
                        positive={q.positive}
                        negative={q.negative}
                        positiveColor="#69AF45"
                        negativeColor="#2B8DCC"
                    />
                ))} */}
            </Grid>
            {
                slug === "senior_leader_survey_questions" && 
                <Grid size={12}>
                     <Typography variant="h6" color="secondary" fontWeight={600} sx={{marginTop:"4px",lineHeight:"1.7"}}>Verbatim Comments</Typography>
                     <List>
                     {
                        feedbackAnsw.map((a,i)=>(
                            <ListItem key={i}>
                                <ListItemIcon>
                                    <CommentIcon/>
                                </ListItemIcon>
                                <ListItemText primary={a.answer}/>
                            </ListItem>
                        ))
                    }
                    </List>
                </Grid>
            }
            {/* <Grid size={12}>
                <BarChart
                    dataset={blockTotal}
                    xAxis={[{min:0,max:100,tickNumber:5,tickLabelStyle:{fontSize:12},position:"top"}]}
                    yAxis={[{scaleType:"band",dataKey:"name",width:1000,tickLabelStyle:{fontSize:15,fontWeight:400,whiteSpace:"normal",textOverflow:"unset"},}]}
                    series={[{dataKey:"positive",label:`Positive`,valueFormatter:(value)=>`${value}%`,stack:"stack",color:"#69AF45"},{dataKey:"negative",label:"Negative",stack:"stack",valueFormatter:(value)=>`${value}%`,color:"#BC4749"}]}
                    layout="horizontal"
                    grid={{vertical:true}}
                    height={100}
                    margin={{right:100,left:-400}}
                    barLabel={(item)=>{if(item.value === 0) return ""; return `${item.value}%`}}
                    sx={{ 
                        [`& .${axisClasses.tickLabel}`]: {
                        whiteSpace: 'pre-wrap',
                        overflow: 'visible',
                        textOverflow: 'unset',
                        },
                        [`& .${chartsGridClasses.line}`]: { strokeWidth: 4 },
                    }}
                />
                {blockTotal.length > 0 && onBlockSummaryChartReady && (
                    <div style={{ position: "absolute", left: -9999, top: -9999 }}>
                        <ExportTIMChart
                        data={blockTotal}
                        labelKey="name"
                        positiveColor={"#69AF45"}
                        graphHeight={150}
                        onImageReady={onBlockSummaryChartReady}
                        />
                    </div>
                )}
            </Grid>  */}    
        </Grid>
    </Box>
    )
}

export default BlockReportTIM